(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-place-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-place-bet.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _svs$components$tipse = svs.components.tipsen.couponId,
  placeWagerAsync = _svs$components$tipse.placeWagerAsync,
  useSetUpMarketplaceBalanceListener = _svs$components$tipse.useSetUpMarketplaceBalanceListener;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const selectActiveWallet = svs.components.tipsen.walletSelectors.selectActiveWallet;
const WALLET_PLAYER = svs.components.tipsen.wallet.walletType.WALLET_PLAYER;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectIsTransferable = _svs$components$tipse2.selectIsTransferable,
  selectRelatedDrawCoupon = _svs$components$tipse2.selectRelatedDrawCoupon;
const _React = React,
  useRef = _React.useRef,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const useDefinition = svs.components.tipsen.engine.utils.useDefinition;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const TRANSFERRING_QUERY_PARAM = 'transfer';
const useTransferable = (couponId, draw) => {
  const isCouponTransferable = useSelector(state => selectIsTransferable(state, couponId));
  const wallet = useSelector(selectActiveWallet);
  const definition = useDefinition();
  const transferModel = useMemo(() => definition.getTransfer(draw), [definition, draw]);
  const isCurrentlyTransferring = useQueryParam(TRANSFERRING_QUERY_PARAM) !== null;
  const isTransferable = !isCurrentlyTransferring && transferModel && isCouponTransferable && (wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_PLAYER && !isSelfService;
  return {
    isTransferable
  };
};
const usePlaceBet = (couponId, draw) => {
  const isPaymentStarted = useRef(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const wallet = useSelector(selectActiveWallet);
  const relatedCoupon = useSelector(state => selectRelatedDrawCoupon(state, couponId));
  let relatedCouponId;
  if (relatedCoupon) {
    const relatedProductId = relatedCoupon.productId,
      relatedDrawNumber = relatedCoupon.drawNumber;
    relatedCouponId = "".concat(relatedProductId, "_").concat(relatedDrawNumber, "_pix");
  }
  const definition = useDefinition();
  const drawProductIds = useMemo(() => (definition === null || definition === void 0 ? void 0 : definition.drawProductIds) || [], [definition]);
  const _useTransferable = useTransferable(couponId, draw),
    isTransferable = _useTransferable.isTransferable;
  useSetUpMarketplaceBalanceListener();
  const newPaymentCallback = useCallback(async () => {
    if (isPaymentStarted.current) {
      return;
    }
    isPaymentStarted.current = true;
    try {
      return await placeWagerAsync({
        dispatch,
        couponId,
        wallet,
        history,
        relatedCouponId,
        isTransferable,
        drawProductIds
      });
    } finally {
      isPaymentStarted.current = false;
      const isExternal = couponId.includes('external_system');
      if (isExternal) {
        history.replace("/".concat(TipsenModuleGameUrl.STANDARD));
      }
    }
  }, [dispatch, couponId, wallet, history, relatedCouponId, isTransferable, drawProductIds]);
  return newPaymentCallback;
};
setGlobal('svs.components.tipsen.couponId.usePlaceBet', usePlaceBet);

 })(window);